(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.bundlePickerSaleTimer) return;
    window.bundlePickerSaleTimer = true;

    const pad = (value) => String(value).padStart(2, '0');

    const tick = () => {
      const now = Date.now() / 1000;
      document.querySelectorAll('[data-sale-ends]').forEach((banner) => {
        const ends = Date.parse(banner.dataset.saleEnds) / 1000;
        const left = Number.isNaN(ends) ? 0 : ends - now;
        const picker = banner.closest('.bundle-picker');

        if (left <= 0) {
          picker?.querySelectorAll('[data-sale-only]').forEach((node) => (node.hidden = true));
          picker?.querySelectorAll('[data-regular-only]').forEach((node) => (node.hidden = false));
          return;
        }

        const days = Math.floor(left / 86400);
        const hours = Math.floor((left % 86400) / 3600);
        const minutes = Math.floor((left % 3600) / 60);
        const seconds = Math.floor(left % 60);
        const countdown = banner.querySelector('[data-sale-countdown]');
        if (countdown) {
          countdown.textContent = `${days > 0 ? `${days}d ` : ''}${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
        }
      });
    };

    tick();
    setInterval(tick, 1000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["happy-kids"] && !Shopify.designMode) return;
  try {
    (() => {
    const run = () => {
      document.querySelectorAll('.happy-kids:not([data-ready])').forEach((el) => {
        el.dataset.ready = '1';
        const num = el.querySelector('.happy-kids__num');
        const target = Number(el.dataset.target) || 0;
        num.textContent = target.toLocaleString('en-US');
        if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        num.textContent = '0';
        new IntersectionObserver((entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          const start = performance.now();
          const tick = (now) => {
            const p = Math.min((now - start) / 1400, 1);
            num.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))).toLocaleString('en-US');
            if (p < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        }).observe(el);
      });
    };
    run();
    document.addEventListener('shopify:section:load', run);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["offer-delivery-timeline"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gs-eta-timeline')) {
    class GsEtaTimeline extends HTMLElement {
      connectedCallback() {
        this.render();
      }

      addBusinessDays(date, n) {
        const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        while (n > 0) {
          d.setDate(d.getDate() + 1);
          const wd = d.getDay();
          if (wd !== 0 && wd !== 6) n--;
        }
        return d;
      }

      render() {
        const num = (key) => parseInt(this.dataset[key], 10) || 0;
        const fmtMD = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
        const fmtD = new Intl.DateTimeFormat('en-US', { day: 'numeric' });
        const range = (a, b) => {
          if (a.getTime() === b.getTime()) return fmtMD.format(a);
          if (a.getMonth() === b.getMonth()) return `${fmtMD.format(a)}–${fmtD.format(b)}`;
          return `${fmtMD.format(a)} – ${fmtMD.format(b)}`;
        };

        const today = new Date();
        const shipA = this.addBusinessDays(today, num('prepMin'));
        const shipB = this.addBusinessDays(today, num('prepMax'));
        const delA = this.addBusinessDays(shipA, num('transitMin'));
        const delB = this.addBusinessDays(shipB, num('transitMax'));

        const set = (key, text) => {
          const el = this.querySelector(`[data-eta="${key}"]`);
          if (el) el.textContent = text;
        };
        set('order', fmtMD.format(today));
        set('ship', range(shipA, shipB));
        set('deliver', range(delA, delB));

        const xmas = this.querySelector('[data-eta="xmas"]');
        if (xmas) {
          const cutoff = new Date(today.getFullYear(), 11, 22);
          xmas.hidden = !(this.dataset.xmas === 'true' && today.getMonth() >= 9 && delB <= cutoff);
        }
      }
    }
    customElements.define('gs-eta-timeline', GsEtaTimeline);
  }
  } catch(e) { console.error(e); }
})();

})();
